import type {DefaultOptions} from '../../types';
import type {BooleanValueEditorOptions} from './types';
import type {BooleanValueEditorLocalizations} from './types';

/**
 * @ngdoc constant
 * @name BOOLEAN_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.boolean
 *
 * @description
 * For description see {@link BooleanValueEditorOptions}
 *
 * ```javascript
 *  {
 *      type: 'switch',
 *      trueValue: undefined,
 *      falseValue: undefined,
 *      customEmptyAsNullCheck: ({value}) => value === false,
 *  }
 * ```
 */
export const BOOLEAN_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<BooleanValueEditorOptions> = {
    trueValue: undefined,
    falseValue: undefined,
    customEmptyAsNullCheck: ({value}) => value === false,
};

/**
 * @ngdoc constant
 * @name BOOLEAN_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.boolean
 *
 * @description
 * ```
 * {
 *      description: ''
 * }
 * ```
 */
export const BOOLEAN_VALUE_EDITOR_DEFAULT_LOCALIZATIONS: Readonly<Required<BooleanValueEditorLocalizations>> = Object.freeze({
    description: ''
});

